import { ArrowButton } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router";

import StaticField from "../../components/StaticField";
import { codebookRouteLanguage } from '../../routes/routes';
import styles from "./RequestCodeBook.module.scss";

export default function CodeBookLanguageDetail(): JSX.Element {
  const history = useHistory();
  const location = useLocation();
  const { t } = useTranslation();
 
  const navigateToLanguage = () => {
    history.push(
      codebookRouteLanguage()
    );
  };

  return (
    <>
      <Row>
        <Col md={12}>
          <ArrowButton
            backwards
            ariaLabel=""
            onClick={navigateToLanguage}
          />
          <span className={styles.backButtonCaption}>
            {t("codeBook.navigateToCodeBook")}
          </span>

        </Col>
      </Row>
      <Row className="mt-5">
        <Col md={8}>
          <h3>{t("codeBook.language")}</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12} className="mt-5">
          <StaticField
            label={t("common.name")}
            value={(location.state as any).language.name}
          />
        </Col>
      </Row>
    </>
  );
}